import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import PHPSetSendFeatureFlagsTrue from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-php-set-send-feature-flags-to-true.mdx";
import PHPOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/php.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  PHPSetSendFeatureFlagsTrue,
  PHPOverrideServerProperties,
  React
};